import React from 'react';

import ClubItem from './ClubItem'

import Header from '../Header/Header'
import Footer from '../Footer/Footer'

import ImgClubPalermo from './../../assets/images/clubs/palermo.jpg';
import ImgClubCaballito from './../../assets/images/clubs/caballito.jpg';
import ImgClubRamos from './../../assets/images/clubs/ramos.jpg';
import ImgClubTorcuato from './../../assets/images/clubs/torcuato.jpg';

// clubs stateless component
const ClubList = () =>
	<div>
		<Header />
		<section className="section">
			<div className="container">
				<ClubItem image = {ImgClubCaballito}
				          title = "Sede Caballito"
				          subtitle = "Sensei Richard Robinson, Sandan"
				          address = "General Manuel A Rodriguez 1191, Caballito, Capital Federal"
					  url = "http://maps.apple.com/?daddr=1191+General+Manuel+A+Rodríguez,+CABA"
					  instagram = "https://www.instagram.com/caballitojiujitsuclub/"
					  whatsapp = "https://wa.me/541130594142">
						Lunes, 19:00 - 20:30
						<br/>
						Miercoles, 18:30 - 20:00
						<br/>
						Viernes, 19:00 - 20:30
				</ClubItem>
				<ClubItem image = {ImgClubRamos}
				          title = "Sede Ramos Mejía"
				          subtitle = "Sensei Jose María Vaquer, Shodan"
				          address = "Gabriel Ardoino 430, Ramos Mejía, Buenos Aires"
					  url = "http://maps.apple.com/?daddr=430+Gabriel+Ardoino,+Ramos+Mejía"
					  facebook = "https://www.facebook.com/p/Haedo-Jiu-Jitsu-Club-100057642211295/"
					  instagram = "https://www.instagram.com/haedojiujitsuclub/">
						Martes, 19:30 - 21:00
						<br/>
						Jueves, 19:30 - 21:00
				</ClubItem>
			</div>
		</section>
		<Footer />
	</div>

export default ClubList;



// WEBPACK FOOTER //
// ./src/components/Info/Clubs.js